import React__default, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, Col } from '@sravni/react-design-system/lib/Grid';
import { Heading, Text, Link } from '@sravni/react-design-system/lib/Typography';
import { useStyles, useIsMobile } from '@sravni/react-utils';
import { formatPhoneToDisplayView } from '../../../../helpers/phone.js';
import '../../../ContextProvider/components/IsLoadingProvider/provider.js';
import { useIsLoading } from '../../../ContextProvider/components/IsLoadingProvider/hook.js';
import '../../../ContextProvider/components/IsOTPSendedProvider/provider.js';
import { useIsOTPSended } from '../../../ContextProvider/components/IsOTPSendedProvider/hook.js';
import { GetOTPLink } from '../../../GetOTPLink/view.js';
import { OTPInput } from '../../../OTPInput/view.js';
import { ServerErrorMessage } from '../../../ServerErrorMessage/view.js';
import { SubmitButton } from '../../../SubmitButton/view.js';
import modules_13b53a7e from '../../styles.module.less.js';

const OTPScreen = (props) => {
    const { onGetOTPClick, onChangePhoneClick } = props;
    const cx = useStyles(modules_13b53a7e);
    const { watch } = useFormContext();
    const [_, setIsOTPSended] = useIsOTPSended();
    const [isLoading] = useIsLoading();
    const isMobile = useIsMobile();
    const phone = watch("phone" /* FIELD_NAME.PHONE */);
    const handleChangePhoneClick = useCallback((event) => {
        setIsOTPSended(false);
        onChangePhoneClick?.(event);
    }, [setIsOTPSended, onChangePhoneClick]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Heading, { level: 3, className: cx('title') }, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 \u0441\u043C\u0441"),
        React__default.createElement(Text, { size: 14, className: cx('subTitle') },
            "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u043A\u043E\u0434 \u043D\u0430 \u043D\u043E\u043C\u0435\u0440",
            React__default.createElement("br", null),
            formatPhoneToDisplayView(phone)),
        React__default.createElement(Row, { className: cx('fields'), gutter: [0, 24] },
            React__default.createElement(Col, { span: 12 },
                React__default.createElement(OTPInput, { loading: !isMobile && isLoading })),
            isMobile ? (React__default.createElement(Col, { span: 12 },
                React__default.createElement(SubmitButton, { size: 52 }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u043A\u043E\u0434"))) : null,
            React__default.createElement(ServerErrorMessage, { className: cx('serverError') }),
            React__default.createElement(Col, { span: 12, className: cx('actions') },
                React__default.createElement(GetOTPLink, { inputName: "code" /* FIELD_NAME.OTP */, size: 14, className: cx('action'), onClick: onGetOTPClick }),
                React__default.createElement(Link, { onClick: handleChangePhoneClick, className: cx('action') },
                    React__default.createElement(Text, { size: 14 }, "\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u043E\u043C\u0435\u0440"))))));
};

export { OTPScreen };
//# sourceMappingURL=index.js.map
